import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'round'
})
export class RoundPipe implements PipeTransform {

  transform(value: number) {
    if (!value) return 0;
    return Math.round(value);
  }

}
